import React, { useContext, useEffect, useState } from "react";
import { ContextProviderComponent, AppContext } from "src/layouts/Context.js";
import { useStaticQuery, graphql } from "gatsby";

import GlobalStyle from "src/assets/styles/globalStyles.js";
import BgVideo from "src/components/global/BgVideo.js";

const IndexPage = ({ children }) => {
  const [vimeoData, setVimeoData] = useState(null);
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [vimeoDataSecondary, setVimeoDataSecondary] = useState(null);
  const [thumbnailImageSecondary, setThumbnailImageSecondary] = useState(null);
  const [headerTopHeight, setHeaderTopHeight] = useState(null);
  const [curentVid, setCurentVid] = useState(null);

  const context = useContext(AppContext);

  // useEffect(() => {
  //   if (context?.data?.vimeo) {
  //     setVimeoData(context.data.vimeo);
  //   }
  //   if (context?.data?.thumbnailImage) {
  //     setThumbnailImage(context.data.thumbnailImage);
  //   }
  //   if (context?.data?.vimeoSecondary) {
  //     setVimeoDataSecondary(context.data.vimeoSecondary);
  //   }
  //   if (context?.data?.thumbnailImageSecondary) {
  //     setThumbnailImageSecondary(context.data.thumbnailImageSecondary);
  //   }
  //   if (context?.data?.headerTopHeight !== undefined) {
  //     setHeaderTopHeight(context.data.headerTopHeight);
  //   }
  // }, [
  //   context?.data?.vimeo,
  //   context?.data?.thumbnailImage,
  //   context?.data?.vimeoSecondary,
  //   context?.data?.thumbnailImageSecondary,
  //   context?.data?.headerTopHeight,
  // ]);

  return (
    <main>
      {/* <BgVideo
        key={vimeoData}
        show={curentVid == vimeoData}
        vimeo={vimeoData}
        thumbnailImage={thumbnailImage}
      />
      <BgVideo
        key={vimeoDataSecondary}
        show={curentVid == vimeoDataSecondary}
        vimeo={vimeoDataSecondary}
        thumbnailImage={thumbnailImageSecondary}
      /> */}
      <GlobalStyle />
      {children}
      <svg height={0} xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
          <filter id="fancy-goo" color-interpolation-filters="sRGB">
            <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
            <feColorMatrix
              in="blur"
              type="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 7 -3"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
    </main>
  );
};

export default IndexPage;
